<template>
  <div class="form-container">
    <van-form>
      <div class="card-box">
        <div class="left">身份证上传</div>
        <div class="right">
          <label v-show="idCardIsUpload">上传成功</label>
          <img
            @click="handleIdCardClick(1)"
            v-show="!idCardIsUpload"
            :src="require('@/assets/imgs/upload/upload_before.svg')"
            class="upload-before"
            style="top: -10px"
          />
          <img
            @click="handleIdCardClick(1)"
            v-show="idCardIsUpload"
            :src="require('@/assets/imgs/upload/upload_after.svg')"
            class="upload-before"
          />
          <input
            type="file"
            ref="rfile1"
            @change="handleUploadChange($event, 1)"
            style="display: none"
            accept="image/*"
          />
        </div>
      </div>

      <van-field
        v-model="dataForm.insuredId"
        name="被保人身份证"
        label="被保人身份证"
        placeholder="请输入被保人身份证"
        @blur="handleInsuredIdBlur"
        v-on:input="
          dataForm.insuredId = dataForm.insuredId.replace(/[^\d|X|x]/g, '')
        "
      />
      <van-field
        v-model="dataForm.insuredName"
        name="被保人姓名"
        label="被保人姓名"
        placeholder="被保人姓名"
      />
      <van-field
        v-model="dataForm.assistantAddress"
        name="被保人地址"
        label="被保人地址"
        placeholder="请输入被保险人地址"
      />
      <van-field
        readonly
        clickable
        name="保险类型"
        label="保险类型"
        :value="productValue"
        placeholder="请选择保险类型"
        @click="showBxPicker = true"
      />
      <div class="card-box">
        <div class="left">行驶证上传</div>
        <div class="right">
          <label v-show="carCardIsUpLoad">上传成功</label>
          <img
            @click="handleIdCardClick(2)"
            v-show="!carCardIsUpLoad"
            :src="require('@/assets/imgs/upload/upload_before.svg')"
            class="upload-before"
            style="top: -10px"
          />
          <img
            @click="handleIdCardClick(2)"
            v-show="carCardIsUpLoad"
            :src="require('@/assets/imgs/upload/upload_after.svg')"
            class="upload-before"
          />
          <input
            type="file"
            ref="rfile2"
            @change="handleUploadChange($event, 2)"
            style="display: none"
            accept="image/*"
          />
        </div>
      </div>
      <van-field
        v-model="dataForm.carOwnerPhone"
        name="手机号"
        label="手机号"
        placeholder="请输入手机号"
      />
      <div style="position: relative">
        <van-field
          v-model="dataForm.carOwnerId"
          name="车主身份证号"
          label="车主身份证号"
          placeholder="请输入车主身份证号"
          :readonly="switchValue"
        />
        <switchs
          class="switch-box"
          v-model="switchValue"
          text="本人|他人"
          @change="handleSwitchChange"
        ></switchs>
      </div>
      <van-field
        v-model="dataForm.frameNo"
        name="车架号"
        label="车架号"
        placeholder="请输入车架号"
      />
      <van-field
        v-model="dataForm.carOwnerName"
        name="车主姓名"
        label="车主姓名"
        placeholder="请输入车主姓名"
      />
      <van-field
        v-model="dataForm.carOwnerAddress"
        name="车主地址"
        label="车主地址"
        placeholder="请输入车主地址"
      />
      <van-field
        v-model="dataForm.licenseNo"
        name="车牌号"
        label="车牌号"
        placeholder="请输入车牌号"
      />
      <van-field
        v-model="dataForm.engineNo"
        name="发动机号"
        label="发动机号"
        placeholder="请输入发动机号"
      />
      <van-field
        v-model="dataForm.enrollDate"
        name="初登日期"
        label="初登日期"
        placeholder="请选择初登日期"
        readonly
        @click="showProductPicker = true"
      />
      <van-field
        v-model="dataForm.vehicleModelsh"
        name="车型名称"
        label="车型名称"
        placeholder="请输入车型名称"
      />
    </van-form>
    <van-popup v-model="showProductPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm="dateCongirm"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showProductPicker = false"
      />
    </van-popup>
    <van-cell
      title="客服电话"
      is-link
      value="400-1234567"
      @click="handleCallClick"
    />
    <div style="height: 5rem"></div>
    <div class="button-save">
      <van-button @click="handleGoClick" type="primary" block color="#fe5958"
        >上传资料</van-button
      >
    </div>
    <div class="overlay-box">
      <van-overlay :show="showLoading">
        <div class="wrapper">
          <div class="loadding-box">
            <van-loading type="spinner" color="white" />上传中
          </div>
        </div>
      </van-overlay>
    </div>
    <van-dialog
      v-model="showConfirm"
      title="请核对您的信息"
      show-cancel-button
      @confirm="handleConfirmClick"
      @cancel="handleCancleClick"
      confirm-button-text="确认无误"
      cancel-button-text="重新上传"
    >
      <div class="info-view">
        <p>
          <span>车主姓名：</span>
          {{ dataForm.carOwnerName }}
        </p>
        <p>
          <span>车牌号：</span>
          {{ dataForm.licenseNo }}
        </p>
        <p>
          <span>车架号：</span>
          {{ dataForm.frameNo }}
        </p>
        <p>
          <span>发动机号：</span>
          {{ dataForm.engineNo }}
        </p>
        <p>
          <span>初登日期：</span>
          {{ dataForm.enrollDate }}
        </p>
        <p>
          <span>车型名称：</span>
          {{ dataForm.vehicleModelsh }}
        </p>
        <p>
          <span>被保险人身份证号：</span>
          {{ dataForm.insuredId }}
        </p>
        <p>
          <span>被保险人姓名：</span>
          {{ dataForm.insuredName }}
        </p>
        <p>
          <span>被保险人地址：</span>
          {{ dataForm.assistantAddress }}
        </p>
      </div>
    </van-dialog>
    <form
      action="http://m.epicc.com.cn/wapi/wcar/api/channel"
      method="post"
      ref="form"
    >
      <input
        type="hidden"
        name="channelInfo"
        :value="locationParams.channelInfo"
      />
      <input type="hidden" name="sign" :value="locationParams.sign" />
    </form>
    <a href="tel:18595961771" v-show="false" ref="tels"></a>
    <van-popup v-model="showBxPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="allName"
        :columns="productLists"
        @confirm="handleProductPickerOk"
        @cancel="showBxPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import switchs from "@/components/switch";
import { isMobile, isCard } from "@/utils/validate";
import {
  uploadIdCard,
  uploadCarCard,
  createTrafficInsure,
  getJsapiTicket,
  findCategoryList,
} from "@/api/common";
import qs from "qs";
import { Notify } from "vant";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  components: { switchs },
  data() {
    return {
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(),
      currentDate: "",
      showProductPicker: false,
      showBxPicker: false,
      showConfirm: false,
      switchValue: true,
      idCardIsUpload: false,
      carCardIsUpLoad: false,
      productValue: "",
      productLists: [],
      productOptions: [],
      dataForm: {
        insuredId: "",
        insuredName: "",
        assistantAddress: "",
        licenseNo: "",
        carOwnerName: "",
        carOwnerAddress: "",
        vehicleModelsh: "",
        engineNo: "",
        frameNo: "",
        enrollDate: "",
        carOwnerPhone: "",
        carOwnerId: "",
        assistantEmail: "jingbaoliandong@163.com",
        owner: 1,
        belongerId: "",
        platformId: "",
        productId: "",
        wayId:""
      },
      locationParams: {
        channelInfo: "",
        sign: "",
      },
      showLoading: false,
    };
  },
  created() {
    this.dataForm.productId = this.$route.query.productId || "";
    this.dataForm.belongerId = this.$route.query.belongerId || "";
    this.dataForm.platformId = this.$route.query.platformId || "";
    document.title = "车险";
    if (!this.$ComTools.isEmptyString(this.dataForm.productId)) {
      this._findCategoryByProductId();
    }
    // if (type === "202") {
    //   document.title = "警保联动 交强险 掌上办";
    // } else {
    //   document.title = "车险";
    // }
  },
  mounted() {
    let sUrl = location.href.split("#")[0];
    let sImgUrl = "http://nywx.e-ibdt.cn/file/logo/logo_picc.png";
    getJsapiTicket({ appid: process.env.WXKey, url: sUrl }).then((res) => {
      if (res.code === 0) {
        this.$ComTools.wxShare(
          res.data,
          sUrl,
          sImgUrl,
          "警保联动 交强险 掌上办"
        );
      }
    });
  },
  methods: {
    _findCategoryByProductId() {
      this.productOptions = [];
      this.productLists = [];
      findCategoryList({ productId: this.dataForm.productId, page: 1 }).then(
        (res) => {
          if (res.code == 0) {
            this.productOptions = res.data.list;
            for (let i = 0; i < this.productOptions.length; i++) {
              let oProduct = this.productOptions[i];
              if (this.itemindex == oProduct.id) {
                this.productValue = oProduct.allName;
                this.setValue(oProduct);
              }
              this.productLists.push(this.$ComTools.assertOfDepth(oProduct));
            }
          }
        }
      );
    },
    dateCongirm() {
      this.dataForm.enrollDate = this.timeFormatter(this.currentDate);
      this.showProductPicker = false;
    },
    timeFormatter(timetem) {
      var date = new Date(timetem); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return year + "-" + month + "-" + day;
    },
    handleInsuredIdBlur() {
      if (this.switchValue) {
        this.dataForm.carOwnerId = this.dataForm.insuredId;
      }
    },
    handleSwitchChange(val) {
      this.switchValue = val;
      if (this.switchValue) {
        this.dataForm.carOwnerId = this.dataForm.insuredId;
      } else {
        this.dataForm.carOwnerId = "";
      }
    },
    handleIdCardClick(index) {
      if (index === 1) {
        this.$refs.rfile1.click();
      } else {
        this.$refs.rfile2.click();
      }
    },
    handleUploadChange(e, index) {
      let oFile = e.target.files[0];
      let fd = new FormData();
      fd.append("file", oFile);
      this.showLoading = true;
      switch (index) {
        case 1:
          uploadIdCard(fd).then((res) => {
            this.$refs.rfile1.value = null;
            this.showLoading = false;
            this.idCardIsUpload = true;
            if (
              res.code === 0 &&
              !this.$ComTools.isEmptyString(res.data.result)
            ) {
              this.dataForm.insuredId = res.data.result.number;
              this.dataForm.insuredName = res.data.result.name;
              this.dataForm.assistantAddress = res.data.result.address;
              this.handleInsuredIdBlur();
            }
          });
          break;
        case 2:
          uploadCarCard(fd).then((res) => {
            this.$refs.rfile2.value = null;
            this.showLoading = false;
            this.carCardIsUpLoad = true;
            if (
              res.code == 0 &&
              !this.$ComTools.isEmptyString(res.data.result)
            ) {
              this.dataForm.licenseNo = res.data.result.number;
              this.dataForm.carOwnerName = res.data.result.name;
              this.dataForm.carOwnerAddress = res.data.result.address;
              this.dataForm.vehicleModelsh = res.data.result.model;
              this.dataForm.engineNo = res.data.result.engine_no;
              this.dataForm.frameNo = res.data.result.vin;
              this.dataForm.enrollDate = res.data.result.register_date;
            }
          });
          break;
      }
    },
    handleCallClick() {
      this.$refs.tels.click();
    },
    handleProductPickerOk(a, b) {
      this.productValue = a.allName;
      this.showBxPicker = false;
      this.dataForm.wayId = a.id;
    },
    handleGoClick() {
      if (this.$ComTools.isEmptyString(this.dataForm.insuredId)) {
        return Notify("请输入被保人身份证");
      }
      if (!isCard(this.dataForm.insuredId)) {
        return Notify("被保人身份证格式错误");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.insuredName)) {
        return Notify("请输入被保人姓名");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.assistantAddress)) {
        return Notify("请输入被保人地址");
      }
      if(this.$ComTools.isEmptyString(this.dataForm.wayId)){
         return Notify("请选择保险类型");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.carOwnerPhone)) {
        return Notify("请输入手机号");
      }
      if (!isMobile(this.dataForm.carOwnerPhone)) {
        return Notify("手机号格式错误");
      }
      if (
        !this.switchValue &&
        this.$ComTools.isEmptyString(this.dataForm.carOwnerId)
      ) {
        return Notify("请输入车主身份证号");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.frameNo)) {
        return Notify("请输入车架号");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.carOwnerName)) {
        return Notify("请输入车主姓名");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.carOwnerAddress)) {
        return Notify("请输入车主地址");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.licenseNo)) {
        return Notify("请输入车牌号");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.engineNo)) {
        return Notify("请输入发动机号");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.enrollDate)) {
        return Notify("请输入初登日期");
      }
      if (this.$ComTools.isEmptyString(this.dataForm.vehicleModelsh)) {
        return Notify("请输入车型名称");
      }
      this.showConfirm = true;
    },
    handleConfirmClick() {
      this.showConfirm = false;
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        duration: 0,
      });
      this.$http
        .post(
          "https://nyjbld.picc-henan.net/piccxs/api/query",
          qs.stringify(this.dataForm)
        )
        .then((res) => {
          this.locationParams.channelInfo = res.data.channelInfo;
          this.locationParams.sign = res.data.sign;
          createTrafficInsure(this.dataForm).then((res) => {
            Toast.clear();
            if (res.code === 0) {
              this.$refs.form.submit();
            } else {
              Notify("提交失败，请稍后再试！");
            }
          });
        });
    },
    handleCancleClick() {
      this.showConfirm = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-container {
  width: 100%;
  min-height: 100%;
  .card-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.8rem 1.2rem 0.8rem 1rem;
    background-color: #efeff4;
    .left {
      font-size: 1rem;
      font-weight: 600;
    }
    .right {
      display: flex;
      align-items: center;
      position: relative;
      label {
        color: #fe5958;
        margin-right: 4rem;
      }
      .upload-before {
        height: 2rem;
        width: 2rem;
        position: absolute;
        right: 0;
        top: -2px;
      }
    }
  }
  .switch-box {
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .button-save {
    /deep/ .van-button {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
  .overlay-box {
    /deep/ .van-overlay {
      background-color: transparent;
    }
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .loadding-box {
      width: 6rem;
      background-color: rgba(0, 0, 0, 0.7);
      height: 5rem;
      color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      border-radius: 5px;
      padding: 0.6rem 0;
    }
  }
  .info-view {
    padding: 1rem 1rem;
    p {
      padding: 4px;
      color: #888888;
      font-size: 0.8rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/insurance/insuranceform.vue